// extracted by mini-css-extract-plugin
export default {"tooltipContainer":"surveyResponsesMonthlyTableCell_tooltipContainer__s205l","tooltipItem":"surveyResponsesMonthlyTableCell_tooltipItem__8+vE3"};